import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const reCardClass = css({
    backgroundColor: getThemeColorVar("white", undefined),
    display: "grid",
    borderRadius: "5px",
    border: `1px solid ${getThemeColorVar("border", "default")}`,
});
const reCardHeaderClass = css({
    backgroundColor: getThemeColorVar("white", undefined),
    padding: "10px 15px 9px 15px",
    borderRadius: "4px 4px 0 0",
    borderBottom: `1px solid ${getThemeColorVar("border", "default")}`,
    color: getThemeColorVar("typo", "dark"),
    fontWeight: 600,
});
const reCardFooterClass = css({
    backgroundColor: getThemeColorVar("white", undefined),
    borderRadius: "0 0 4px 4px",
    borderTop: `1px solid ${getThemeColorVar("border", "default")}`,
    color: getThemeColorVar("typo", "dark"),
    padding: "9px 15px 10px 15px",
    fontWeight: 600,
});
const headlineClass = css({
    fontSize: "16px",
    lineHeight: "25px",
});
const contentClass = css({
    padding: "15px",
});
function cardHeader(header) {
    return (React.createElement("div", { className: cx(reCardHeaderClass) }, typeof header === "string" ? (React.createElement("h1", { className: cx(headlineClass) }, header)) : (header)));
}
function cardFooter(footer) {
    return (React.createElement("div", { className: cx(reCardFooterClass) }, typeof footer === "string" ? (React.createElement("h1", { className: cx(headlineClass) }, footer)) : (footer)));
}
function computeTemplateRows(growingElement) {
    switch (growingElement) {
        case "header":
            return "1fr fit-content(100%) fit-content(100%)";
        case "footer":
            return "fit-content(100%) fit-content(100%) 1fr";
        case "body":
        default:
            return "fit-content(100%) 1fr fit-content(100%)";
    }
}
export const Card = (props) => {
    const { footer, header, children, id, growingElement } = props;
    return (React.createElement("div", { className: cx(reCardClass, css({ gridTemplateRows: computeTemplateRows(growingElement) })), id: id },
        header ? cardHeader(header) : undefined,
        React.createElement("div", { className: contentClass }, children),
        footer ? cardFooter(footer) : undefined));
};
export default Card;
//# sourceMappingURL=card.js.map